import React from "react";
import {
  Button,
  Typography,
  Box,
} from '@mui/material';
import { useTranslation } from 'react-i18next'
import { setUserToVisitMapId, setChangeMapType } from "../../store/controlPanelSlice";
import "./ChangeMap.css";
import { useSelector, useDispatch } from "react-redux";
import { changeMap, getMapSettings } from "../../../Map/store/MapDisplayThunks";
import { joinRoom } from "../../store/interact/interactThunks";
const ChangeMap = ({ onClose }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { userToVisitMapId, changeMapType } = useSelector((state) => state.controlPanel);
  const onConfirm = async (e) => {
    try {
      e.preventDefault();
      if (changeMapType === 'interact') {
        // Wait for map change to complete
        await dispatch(changeMap({ body: { mapId: userToVisitMapId } }));
      }
      if (changeMapType === 'event') {
        // Wait for joinRoom to finish
        await dispatch(
          joinRoom({ body: { targetRoomId: userToVisitMapId } })
        )
      }

      // Only clear state and close modal after all async ops complete
      dispatch(setUserToVisitMapId(''));
      dispatch(setChangeMapType(''));
      onClose && onClose();
    } catch (error) {
      console.error("Error in onConfirm:", error);
      // Optionally show user feedback
    }
  };

  return (
    <Box className="change-map-dialog">
      <Typography style={{ marginLeft: "2%" }} >{t("confirm_change_map")}</Typography>
      <Box display="flex" gap={2} mt={2}>
        <div className="buttons">
          <button
            className="cancel"
            onClick={() => {
              dispatch(setUserToVisitMapId(''));
              dispatch(setChangeMapType(''));
              onClose && onClose();
            }}
          >
            {t("cancel")}
          </button>
          <button
            className="create-btn"
            onClick={(e) => onConfirm(e)}>
            {t("CONFIRM")}
          </button>
        </div>
      </Box>
    </Box>
  );
};

export default ChangeMap;